import { type ThemeId } from '../schema/ThemeId';

const themeIdToColorMap = {
    // Solid Color Themes
    ['Blue']: ['#0078D4', '#0086F0'],
    ['Purple']: ['#9900FA', '#9900FA'],
    ['Pink']: ['#FE46A5', '#FF47A6'],
    ['Orange']: ['#F8481C', '#F7471B'],
    ['Red']: ['#E60045', '#E60045'],
    ['Green']: ['#1FA774', '#1FA675'],

    // Cricket country themes
    ['Afghanistan']: ['#0078CD', '#0F85D8'],
    ['Australia']: ['#00825B', '#00915D'],
    ['Bangladesh']: ['#00934F', '#008E4C'],
    ['Canada']: ['#E8011C', '#F1002B'],
    ['England']: ['#DE0404', '#EE1723'],
    ['India']: ['#0073C2', '#0081D9'],
    ['Ireland']: ['#00882E', '#008F31'],
    ['Namibia']: ['#0072C9', '#007CDA'],
    ['Nepal']: ['#0065C2', '#027AE9'],
    ['Netherlands']: ['#F8481C', '#F7471B'],
    ['NewZealand']: ['#008282', '#009393'],
    ['Oman']: ['#CB0006', '#FB0921'],
    ['Pakistan']: ['#00803B', '#008D41'],
    ['PapuaNewGuinea']: ['#DE0404', '#EE1723'],
    ['Scotland']: ['#7844EB', '#8C61ED'],
    ['SouthAfrica']: ['#00882E', '#008F31'],
    ['SriLanka']: ['#0079D0', '#0082E0'],
    ['Uganda']: ['#DA0A3C', '#EB063E'],
    ['USA']: ['#07359E', '#F7002C'],
    ['WestIndies']: ['#D6155A', '#EC1260'],

    ['Athletics']: ['#008282', '#009393'],
    ['Basketball']: ['#DE0404', '#EE1723'],
    ['Boxing']: ['#DE0404', '#EE1723'],
    ['Football']: ['#0073C2', '#0081D9'],
    ['Gymnastics']: ['#F8481C', '#F7471B'],
    ['Handball']: ['#F8481C', '#F7471B'],
    ['Swimming']: ['#0073C2', '#0081D9'],
    ['Tennis']: ['#00882E', '#008F31'],
    ['Volleyball']: ['#F8481C', '#F7471B'],
    ['Weightlifting']: ['#008282', '#009393'],
};

export const getThemeColorHexCode = (themeId: ThemeId, isDarkTheme: boolean) => {
    const themeColors = themeIdToColorMap[themeId] ?? themeIdToColorMap['Blue'];
    return isDarkTheme ? themeColors[1] : themeColors[0];
};
